import {
    NavigationButton,
    Description,
    HeaderBlock,
    SubTitle,
    Title,
    TitleBlock
} from "./styled";

const Header = () => {
    return (
        <HeaderBlock>
            <TitleBlock>
                <Title>Depilacja</Title>
                <SubTitle>Kateryna</SubTitle>
                <Description>
                    ШУГАРИНГ | ВІСК | ВАРШАВА | DEPILACJA | WOSK<br />
                    Привіт! Я сертифікований майстер депіляції!
                    Запрошую Вас до себе на процедуру&nbsp;😊
                    Доза гладкості без роздратувань чекає саме на тебе&nbsp;❤
                </Description>
                <NavigationButton href="#contact">Записатись</NavigationButton>
            </TitleBlock>
        </HeaderBlock>
    );
};

export default Header;